module.exports = __webpack_public_path__ + "static/US2_4Tenants_v2-a73ac0e7edac430fd78fa46395aea65c.png";